/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitReqVo
 */
export interface SubmitReqVo {
    /**
     * 反馈类型；必传，1错误报告、2改善提议。
     * 必传；反馈类型：1错误报告、2改善提议
     * @type {number}
     * @memberof SubmitReqVo
     */
    type: number;
    /**
     * 反馈标题；必传，100字以内。
     * 必传；反馈标题，100字以内
     * @type {string}
     * @memberof SubmitReqVo
     */
    title: string;
    /**
     * 反馈正文；必传，2000字以内。
     * 必传；反馈正文，2000字以内
     * @type {string}
     * @memberof SubmitReqVo
     */
    content: string;
    /**
     * 附件文件ID集合；非必传，先调 /uploadFiles/upload 上传，仅支持图片，最多9张。
     * 非必传；上传文件ID集合，对应 upload_files.id，仅支持图片，最多9张
     * @type {Array<number>}
     * @memberof SubmitReqVo
     */
    fileIds?: Array<number>;
}

/**
 * Check if a given object implements the SubmitReqVo interface.
 */
export function instanceOfSubmitReqVo(value: object): value is SubmitReqVo {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SubmitReqVoFromJSON(json: any): SubmitReqVo {
    return SubmitReqVoFromJSONTyped(json, false);
}

export function SubmitReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'title': json['title'],
        'content': json['content'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function SubmitReqVoToJSON(json: any): SubmitReqVo {
    return SubmitReqVoToJSONTyped(json, false);
}

export function SubmitReqVoToJSONTyped(value?: SubmitReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'content': value['content'],
        'fileIds': value['fileIds'],
    };
}

